import { render, staticRenderFns } from "./BuyingOrderPage.vue?vue&type=template&id=c3bb819e&scoped=true&"
import script from "./BuyingOrderPage.vue?vue&type=script&lang=js&"
export * from "./BuyingOrderPage.vue?vue&type=script&lang=js&"
import style0 from "./BuyingOrderPage.vue?vue&type=style&index=0&id=c3bb819e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bb819e",
  null
  
)

export default component.exports